import { TrackingDetailsProps } from '../utils/enums/enums';

export const trackingDetailArr: Array<TrackingDetailsProps> = [
  { text: 'trackingContentPosition', pre: '' },
  { text: 'trackingDescription', pre: 'msg=' },
  { text: 'trackingOfferType', pre: 'type=' },
  { text: 'trackingTag', pre: 'tag=' },
];
export const constants = {
  COBRAND_NON_POINTS_MATH: 'cobrandNonPointsMath',
  TARGET_BLANK: '_blank',
  SIMPLE: 'simple',
  OPEN_IN_NEW_TAB: 'Opens a new window',
  NO_OPENER: 'noopener',
  NO_REFERER: 'noreferrer',
  DEFAULT: 'DEFAULT',
  IMG_ALT_TEXT: 'Title',
  HOMEPAGE_HB_16X9_DES_REND2X: '2880px:1620px',
  HOMEPAGE_HB_16X9_TABLET_REND2X: '1536px:864px',
  HOMEPAGE_HB_16X9_MOB_REND2X: '728px:1126px',
  HOMEPAGE_HB_3X1_DES_REND2X: '2880px:960px',
  HOMEPAGE_HB_3X1_TABLET_REND2X: '2880px:960px',
  HOMEPAGE_HB_3X1_MOB_REND2X: '1456px:1456px',
  DOWNSIZE_PARAM: '?output-quality=70&interpolation=progressive-bilinear&downsize=',
  DEFAULT_LANG: 'en_US',
  RTL_LANG_LIST: `:lang(he-IL), :lang(ar-AE)`,
  COBRAND_MATH_HERO_CTA_CLASS: 'cobrand-math-hero-btn',
};
export const cardCodesMapper = {
  updateboundless: [
    'FOCBOT-0513',
    'FOCTOP-0513',
    'SINGLECCBODY1-0513',
    'SINGLECCBODY2-0513',
    'BANKLDPBODY-0513',
    'focHero-0513',
    'CTBANNER-0513',
    'BANKLDPCTBANNER-0513',
    'SINGLECTBANNER-0513',
  ],
  updatebold: [
    'FOCBOT-0532',
    'FOCTOP-0532',
    'SINGLECCBODY1-0532',
    'SINGLECCBODY2-0532',
    'BANKLDPBODY-0532',
    'focHero-0532',
    'CTBANNER-0532',
    'BANKLDPCTBANNER-0532',
    'SINGLECTBANNER-0532',
  ],
  updatebrilliant: [
    'FOCBOT-USPC',
    'FOCTOP-USPC',
    'SINGLECCBODY1-USPC',
    'SINGLECCBODY2-USPC',
    'BANKLDPBODY-USPC',
    'SINGLECCHERO-USPC',
    'focHero-USPC',
    'SINGLECCSTICKY-USPC',
    'CTBANNER-USPC',
    'BANKLDPCTBANNER-USPC',
    'SINGLECTBANNER-USPC',
  ],
  updatebusiness: [
    'FOCBOT-USBU',
    'FOCTOP-USBU',
    'focBanner-USBU',
    'BANKLDPBODY-USBU',
    'focHero-USBU',
    'CTBANNER-USBU',
    'BANKLDPCTBANNER-USBU',
    'SINGLECTBANNER-USBU',
  ],
  updatebevy: [
    'FOCBOT-USMT',
    'FOCTOP-USMT',
    'SINGLECCBODY1-USMT',
    'SINGLECCBODY2-USMT',
    'BANKLDPBODY-USMT',
    'SINGLECCHERO-USMT',
    'focHero-USMT',
    'SINGLECCSTICKY-USMT',
    'CTBANNER-USMT',
    'BANKLDPCTBANNER-USMT',
    'SINGLECTBANNER-USMT',
  ],
  updatecompboundless: ['CARDCOMPPGHDR-0513'],
  updatecompbold: ['CARDCOMPPGHDR-0532'],
  updatecompbrilliant: ['CARDCOMPPGHDR-USPC'],
  updatecompbusiness: ['CARDCOMPPGHDR-USBU'],
  updatecompbevy: ['CARDCOMPPGHDR-USMT'],
  updatesmbsclplm: ['SINGLECCHERO-USBU'],
  updatesmbsclpan: ['SINGLECCBODY1-USBU', 'SINGLECCBODY2-USBU', 'SINGLECCSTICKY-USBU'],
  updateboundlessblphero: ['chaseBLPHero-0513'],
  updateboldblphero: ['chaseBLPHero-0532'],
  updatebusinessblphero: ['amexBLPHero-USBU'],
  updatebevyblphero: ['amexBLPHero-USMT'],
  updatebrilliantblphero: ['amexBLPHero-USPC'],
};
export const chaseCodes = [
  'updateboundless',
  'updatebold',
  'updatecompboundless',
  'updatecompbold',
  'updateboundlessblphero',
  'updateboldblphero',
];
export const amexCodes = [
  'updatebrilliant',
  'updatebusiness',
  'updatebevy',
  'updatecompbrilliant',
  'updatecompbusiness',
  'updatecompbevy',
  'updatesmbsclplm',
  'updatesmbsclpan',
  'updatebusinessblphero',
  'updatebevyblphero',
  'updatebrilliantblphero',
];
export const DCACodes = [
  'updateboundlessblphero',
  'updateboldblphero',
  'updatebusinessblphero',
  'updatebevyblphero',
  'updatebrilliantblphero',
];
export const config = {
  gcv: 'AMCV_664516D751E565010A490D4C@AdobeOrg',
  cookie: 'MCMID',
  ctaURL: '/mi/cobrand/chase.mi?returnURL=/loyalty/myAccount/profile.mi&destinationURL=',
  cname: 'merchViewed',
  code1: '0513',
  code2: '0532',
  HIO: 'HIO',
  ctaUrlChasePrefix: '&returnURL=',
  ctaUrlChase: '/loyalty/myAccount/profile.mi',
  ctaUrlAmex: '/mi/cobrand/amex.mi?destinationURL=',
  ctaUrlAmexEvergreen: 'https://www.marriott.com/mi/cobrand/amex.mi?destinationURL=',
};

export const AccordionHiddenClasses = ['collapsed', 'hide-visibility'];
export const HEIGHT_VALUE = 3.75;
export const PX_TO_REM = 0.0625;
export const LOCALE_ZH_CN = 'zh-CN';
export const MOMENT_CN_LANG = 'zh-cn';
export const HINDI_LANG = 'hi-IN';

export const CN_RATING_TOOLTIP = '评分是基于客户完成住宿后在满意度调查中提供的客户评分整理得出的。';

export enum checkboxVariation {
  SIMPLE = 'simple',
  SWITCH = 'switch',
}
